import "./MembershipPayment.css";

import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import {
  FaLock,
  FaShieldAlt,
  FaCheckCircle,
  FaFileInvoice,
  FaUsers,
  FaBars,
  FaTimes,
} from "react-icons/fa";

// ==========================================================
// LOGO
// ==========================================================

import logo from "../../assets/images/Logo.jpeg";


function MembershipPayment() {

  const navigate = useNavigate();
  const location = useLocation();

  // ==========================================================
  // STATE
  // ==========================================================

  const [upiId, setUpiId] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [error, setError] = useState("");


  // ==========================================================
  // PAYMENT AMOUNT
  // ==========================================================

  const membershipFee = 1299;
  const convenienceFee = 0;
  const totalAmount =
    membershipFee + convenienceFee;


  // ==========================================================
  // MERCHANT DETAILS
  // ==========================================================

  const merchantUpiId =
    "apnbtrust@rzp";

  const merchantName =
    "ABNB Seva Samithi";


  // ==========================================================
  // CLOSE MENU
  // ==========================================================

  const closeMenu = () => {
    setMenuOpen(false);
  };


  // ==========================================================
  // GET REGISTRATION DATA
  // ==========================================================

  const getRegistrationData = () => {

    let registrationData = {};
    let formData = {};

    try {

      const savedRegistrationData =
        localStorage.getItem(
          "registrationData"
        );

      if (savedRegistrationData) {

        registrationData =
          JSON.parse(
            savedRegistrationData
          );
      }

    } catch (error) {

      console.error(
        "Unable to read registrationData:",
        error
      );
    }


    try {

      const savedFormData =
        localStorage.getItem(
          "formData"
        );

      if (savedFormData) {

        formData =
          JSON.parse(
            savedFormData
          );
      }

    } catch (error) {

      console.error(
        "Unable to read formData:",
        error
      );
    }


    const combinedData = {

      ...formData,

      ...registrationData,

      ...(location.state?.formData || {}),
    };


    const memberName =
      combinedData.memberName ||
      combinedData.fullName ||
      combinedData.name ||
      (
        combinedData.firstName &&
        combinedData.lastName
          ? `${combinedData.firstName} ${combinedData.lastName}`
          : combinedData.firstName
      ) ||
      "Member";


    const mobileNumber =
      combinedData.mobileNumber ||
      combinedData.mobile ||
      combinedData.phoneNumber ||
      combinedData.phone ||
      "";


    return {

      ...combinedData,

      memberName,

      mobileNumber,
    };
  };


  // ==========================================================
  // CREATE UPI URL
  // ==========================================================

  const createUPIUrl = () => {

    const params =
      new URLSearchParams({

        pa: merchantUpiId,

        pn: merchantName,

        am:
          totalAmount.toFixed(2),

        cu: "INR",
      });


    return `upi://pay?${params.toString()}`;
  };


  // ==========================================================
  // OPEN UPI APP
  // ==========================================================

  const openUPIApp = (app) => {

    setError("");


    const encodedMerchant =
      encodeURIComponent(
        merchantUpiId
      );


    const encodedName =
      encodeURIComponent(
        merchantName
      );


    const amount =
      totalAmount.toFixed(2);


    let appUrl =
      createUPIUrl();


    switch (app) {

      case "gpay":

        appUrl =
          `tez://upi/pay?pa=${encodedMerchant}` +
          `&pn=${encodedName}` +
          `&am=${amount}` +
          `&cu=INR`;

        break;


      case "phonepe":

        appUrl =
          `phonepe://pay?pa=${encodedMerchant}` +
          `&pn=${encodedName}` +
          `&am=${amount}` +
          `&cu=INR`;

        break;


      case "paytm":

        appUrl =
          `paytmmp://pay?pa=${encodedMerchant}` +
          `&pn=${encodedName}` +
          `&am=${amount}` +
          `&cu=INR`;

        break;


      case "bhim":

        appUrl =
          `bhim://pay?pa=${encodedMerchant}` +
          `&pn=${encodedName}` +
          `&am=${amount}` +
          `&cu=INR`;

        break;


      default:

        appUrl =
          createUPIUrl();
    }


    window.location.href =
      appUrl;


    setTimeout(() => {

      window.location.href =
        createUPIUrl();

    }, 1500);
  };


  // ==========================================================
  // PAYMENT BUTTON
  // ==========================================================

  const handlePayment = () => {

    setError("");


    // --------------------------------------------------------
    // TERMS CHECK
    // --------------------------------------------------------

    if (!termsAccepted) {

      setError(
        "Please accept the Terms & Conditions and Refund Policy."
      );

      return;
    }


    // --------------------------------------------------------
    // GET REGISTRATION DATA
    // --------------------------------------------------------

    const registrationData =
      getRegistrationData();


    const memberName =
      registrationData.memberName ||
      "Member";


    const mobileNumber =
      registrationData.mobileNumber ||
      "";


    // --------------------------------------------------------
    // GENERATE DEMO PAYMENT INFORMATION
    // --------------------------------------------------------

    const transactionId =
      "PAY" +
      Date.now()
        .toString()
        .slice(-10);


    const orderId =
      "ORD" +
      Date.now()
        .toString()
        .slice(-10);


    const membershipId =
      "APNBM" +
      Date.now()
        .toString()
        .slice(-8);


    // --------------------------------------------------------
    // PAYMENT DATE
    // --------------------------------------------------------

    const paymentDate =
      new Date().toLocaleString(
        "en-IN",
        {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }
      );


    // --------------------------------------------------------
    // VALID TILL
    // --------------------------------------------------------

    const validTillDate =
      new Date();


    validTillDate.setFullYear(
      validTillDate.getFullYear() + 1
    );


    validTillDate.setDate(
      validTillDate.getDate() - 1
    );


    const validTill =
      validTillDate.toLocaleDateString(
        "en-IN",
        {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }
      );


    // --------------------------------------------------------
    // PAYMENT DATA
    // --------------------------------------------------------

    const paymentData = {

      memberName,

      mobileNumber,

      transactionId,

      orderId,

      paymentDate,

      amount:
        totalAmount,

      membershipFee,

      convenienceFee,

      paymentMethod:
        "UPI",

      paymentGateway:
        "Razorpay",

      paymentStatus:
        "SUCCESS",

      membershipType:
        "Annual Membership",

      membershipId,

      validTill,

      upiId:
        upiId.trim() ||
        "UPI Payment",
    };


    // ========================================================
    // SAVE REGISTRATION DATA
    // ========================================================

    localStorage.setItem(
      "registrationData",
      JSON.stringify(
        registrationData
      )
    );


    // ========================================================
    // SAVE PAYMENT DATA
    // ========================================================

    localStorage.setItem(
      "paymentData",
      JSON.stringify(
        paymentData
      )
    );


    // ========================================================
    // SAVE BASIC MEMBER DATA
    // ========================================================

    localStorage.setItem(
      "memberName",
      memberName
    );


    localStorage.setItem(
      "mobileNumber",
      mobileNumber
    );


    // ========================================================
    // GO TO PAYMENT SUCCESS
    // ========================================================

    navigate(
      "/payment-success",
      {
        state: {
          paymentData:
            paymentData,

          formData:
            registrationData,
        },
      }
    );
  };


  // ==========================================================
  // RENDER
  // ==========================================================

  return (

    <div className="membership-payment-page">


      {/* ====================================================
          HEADER
      ==================================================== */}

      <header className="payment-header">

        <div className="payment-header-inner">


          {/* ==================================================
              BRAND
          ================================================== */}

          <Link
            to="/"
            className="payment-brand"
            onClick={closeMenu}
          >

            <div className="payment-brand-logo">

              <img
                src={logo}
                alt="ABNB Seva Samithi Logo"
              />

            </div>


            <div className="payment-brand-text">

              <strong>
                ABNB SEVA SAMITHI
              </strong>

              <span>
                & VIDYA CHARITABLE TRUST
              </span>

            </div>

          </Link>


          {/* ==================================================
              MOBILE MENU
          ================================================== */}

          <button
            type="button"
            className="mobile-menu-button"
            onClick={() =>
              setMenuOpen(
                (previous) =>
                  !previous
              )
            }
            aria-label="Toggle navigation"
          >

            {menuOpen ? (
              <FaTimes />
            ) : (
              <FaBars />
            )}

          </button>


          {/* ==================================================
              NAVIGATION
          ================================================== */}

          <nav
            className={`payment-navigation ${
              menuOpen
                ? "menu-open"
                : ""
            }`}
          >

            <Link
              to="/"
              onClick={closeMenu}
            >
              HOME
            </Link>


            <Link
              to="/about"
              onClick={closeMenu}
            >
              ABOUT
            </Link>


            <Link
              to="/membership"
              onClick={closeMenu}
            >
              MEMBERSHIP
            </Link>


            




            <Link
              to="/downloads"
              onClick={closeMenu}
            >
              DOWNLOADS
            </Link>


            <Link
              to="/contact"
              onClick={closeMenu}
            >
              CONTACT
            </Link>


            

          </nav>

        </div>

      </header>


      {/* ====================================================
          SECURITY BAR
      ==================================================== */}

      


      {/* ====================================================
          MAIN
      ==================================================== */}

      <main className="payment-main-container">


        {/* ==================================================
            UPI PAYMENT
        ================================================== */}

        <section className="payment-method-box card-box">


          <div className="upi-payment-panel">

            <h3>
              Pay using UPI
            </h3>


            {/* ==================================================
                QR CODE
            ================================================== */}

            <div className="qr-container">

              <div className="qr-image-wrapper">

                <img
                  src="/images/qr-code.png"
                  alt="UPI QR Code"
                  className="qr-code"
                />

              </div>


              <div className="upi-vpa">
                {merchantUpiId}
              </div>


              {/* ==================================================
                  UPI APPS
              ================================================== */}

              <div className="upi-apps">

                <button
                  type="button"
                  className="upi-app-button"
                  onClick={() =>
                    openUPIApp(
                      "bhim"
                    )
                  }
                >
                  BHIM
                </button>


                <button
                  type="button"
                  className="upi-app-button"
                  onClick={() =>
                    openUPIApp(
                      "gpay"
                    )
                  }
                >
                  Google Pay
                </button>


                <button
                  type="button"
                  className="upi-app-button"
                  onClick={() =>
                    openUPIApp(
                      "paytm"
                    )
                  }
                >
                  Paytm
                </button>


                <button
                  type="button"
                  className="upi-app-button"
                  onClick={() =>
                    openUPIApp(
                      "phonepe"
                    )
                  }
                >
                  PhonePe
                </button>

              </div>

            </div>


            {/* ==================================================
                SCAN TEXT
            ================================================== */}

            <p className="scan-text">
              Scan this QR code or select your UPI app to pay
            </p>


            {/* ==================================================
                OR DIVIDER
            ================================================== */}

            <div className="or-divider">

              <span></span>

              <b>
                OR
              </b>

              <span></span>

            </div>


            {/* ==================================================
                UPI ID
            ================================================== */}

            <div className="input-group">

              <label htmlFor="upiId">
                Enter UPI ID
              </label>

              <input
                id="upiId"
                type="text"
                value={upiId}
                onChange={(event) => {

                  setUpiId(
                    event.target.value
                  );

                  setError("");
                }}
                placeholder="example@upi"
                autoComplete="off"
              />

            </div>


            {/* ==================================================
                ERROR
            ================================================== */}

            {error && (

              <div className="payment-error">
                {error}
              </div>

            )}


            {/* ==================================================
                PAY BUTTON
            ================================================== */}

            <button
              type="button"
              className="pay-button"
              onClick={
                handlePayment
              }
            >
              PAY ₹1299
            </button>

          </div>


          {/* ==================================================
              SECURITY FEATURES
          ================================================== */}

          <div className="payment-security-features">


            <div>

              <FaLock />

              <div>

                <strong>
                  Secure SSL
                </strong>

                <span>
                  256-bit Encryption
                </span>

              </div>

            </div>


            <div>

              <FaShieldAlt />

              <div>

                <strong>
                  Trusted Payment
                </strong>

                <span>
                  Razorpay Secure
                </span>

              </div>

            </div>


            <div>

              <FaCheckCircle />

              <div>

                <strong>
                  100% Safe
                </strong>

                <span>
                  Your data is protected
                </span>

              </div>

            </div>


            <div>

              <FaFileInvoice />

              <div>

                <strong>
                  Instant Receipt
                </strong>

                <span>
                  On successful payment
                </span>

              </div>

            </div>

          </div>

        </section>


        {/* ====================================================
            TERMS
        ==================================================== */}

        <div className="terms-box">

          <input
            id="terms"
            type="checkbox"
            checked={
              termsAccepted
            }
            onChange={(event) =>
              setTermsAccepted(
                event.target.checked
              )
            }
          />

          <label htmlFor="terms">

            I agree to{" "}

            <strong>
              Terms & Conditions
            </strong>{" "}

            and{" "}

            <strong>
              Refund Policy
            </strong>.

          </label>

        </div>


        {/* ====================================================
            AFTER PAYMENT
        ==================================================== */}

        <div className="after-payment card-box">

          <h2>
            What happens after payment?
          </h2>


          <div className="after-payment-grid">


            <div>

              <FaCheckCircle />

              <span>
                Payment confirmation
              </span>

            </div>


            <div>

              <FaUsers />

              <span>
                Membership ID generated
              </span>

            </div>


            <div>

              <FaFileInvoice />

              <span>
                Digital receipt available
              </span>

            </div>


            <div>

              <FaShieldAlt />

              <span>
                Membership becomes active
              </span>

            </div>


          </div>

        </div>

      </main>


      {/* ====================================================
          FOOTER
      ==================================================== */}

      <footer className="payment-footer">

        <span>
          © 2026 ABNB Seva Samithi &
          Vidya Charitable Trust.
          All Rights Reserved.
        </span>


        <div>

          <Link to="/privacy-policy">
            Privacy Policy
          </Link>

          <b>
            |
          </b>

          <Link to="/terms">
            Terms & Conditions
          </Link>

          <b>
            |
          </b>

          <Link to="/refund-policy">
            Refund Policy
          </Link>

        </div>

      </footer>

    </div>
  );
}

export default MembershipPayment;